package com.starparty.app.astro0

import com.starparty.app.geometry.SP_Rectangle

abstract class SP_Canvas {

   abstract val width: Int

   abstract val height: Int

   abstract val clipBounds: SP_Rectangle

   abstract fun drawColor(c: SP_Colour)

   abstract fun drawText(text:String, x:Double, y:Double, p: SP_Paint)

   abstract fun drawLine(x1:Double, y1:Double, x2:Double, y2:Double, p: SP_Paint)

   abstract fun drawRectFilled(rect: SP_Rectangle, p: SP_Paint)

   abstract fun drawRectUnfilled(rect: SP_Rectangle, p: SP_Paint)

   abstract fun drawCircleFilled(x:Double, y:Double, radius:Double, p: SP_Paint)

   abstract fun drawCircleUnfilled(x:Double, y:Double, radius:Double, p: SP_Paint)

   abstract fun drawOvalUnfilled(rect: SP_Rectangle, p: SP_Paint)

   abstract fun translate(x: Double, y: Double)

}